import { createUseStyles } from 'react-jss';

import { mediaQuery } from '@picsart/rc/helpers';
import {
  CenterAlignedContentMargins,
  CenterAlignedContentWidth,
  BreakPoints,
} from '@picsart/rc/enums';

const useCenteredStyles = createUseStyles(
  {
    content: {
      width: '100%',
      maxWidth: `${CenterAlignedContentWidth.ExtraLarge}px`,
      margin: '0 auto',

      [mediaQuery(BreakPoints.ExtraLarge)]: {
        maxWidth: `${CenterAlignedContentWidth.Adaptive}`,
        padding: `0 ${CenterAlignedContentMargins.Large}px`,
      },
      [mediaQuery(BreakPoints.Large)]: {
        padding: `0 ${CenterAlignedContentMargins.Medium}px`,
      },
      [mediaQuery(BreakPoints.Medium)]: {
        padding: `0 ${CenterAlignedContentMargins.Small}px`,
      },
    },
  },
  {
    name: 'centered',
  },
);

export default useCenteredStyles;
